"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var WindowItemForecastCoordinatorRows =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemForecastCoordinatorRows, _DomainObject_1$Domai);

  /**
   * Creates new instance of WindowItemForecastCoordinatorRows.
   * @param productExternalId
   * @param systemVolume
   * @param promoVolume
   * @param diffAbs
   * @param diffPerc
   */
  function WindowItemForecastCoordinatorRows(productExternalId, systemVolume, promoVolume, diffAbs, diffPerc) {
    var _this;

    _classCallCheck(this, WindowItemForecastCoordinatorRows);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemForecastCoordinatorRows).call(this));
    _this.productExternalId = productExternalId;
    _this.systemVolume = systemVolume;
    _this.promoVolume = promoVolume;
    _this.diffAbs = diffAbs;
    _this.diffPerc = diffPerc;
    return _this;
  }

  return WindowItemForecastCoordinatorRows;
}(DomainObject_1.DomainObject);

exports.WindowItemForecastCoordinatorRows = WindowItemForecastCoordinatorRows;

WindowItemForecastCoordinatorRows.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemForecastCoordinatorRows.name);
  return {
    productExternalId: builder.str('productExternalId'),
    systemVolume: builder.bigNum('systemVolume'),
    promoVolume: builder.bigNum('promoVolume'),
    diffAbs: builder.bigNum('diffAbs'),
    diffPerc: builder.bigNum('diffPerc')
  };
}();